module.exports = __webpack_public_path__ + "static/img/ic_float_service_3.4848c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_float_service_3.png
// module id = BKYz
// module chunks = 0